import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function AnimatedCounter({
  value,
  suffix = '',
  prefix = ''
}: {
  value: number;
  suffix?: string;
  prefix?: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let start = 0;
      const duration = 2000; // 2 seconds
      const increment = value / (duration / 16); // 60fps
      const timer = setInterval(() => {
        start += increment;
        if (start >= value) {
          setCount(value);
          clearInterval(timer);
        } else {
          setCount(start);
        }
      }, 16);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  // Format number based on size
  const formattedCount = count % 1 !== 0 ? count.toFixed(1) : Math.floor(count).toString();
  return <span ref={ref} className="font-mono font-bold text-3xl md:text-4xl text-white" data-id="element-215">
      {prefix}
      {formattedCount}
      {suffix}
    </span>;
}
export function MetricsStrip() {
  return <section className="py-12 border-y border-navy-700 bg-navy-800/50" data-id="element-216">
      <div className="max-w-7xl mx-auto px-6" data-id="element-217">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-navy-700/50" data-id="element-218">
          <div className="flex flex-col items-center justify-center" data-id="element-219">
            <AnimatedCounter value={2.4} prefix="€" suffix="B+" data-id="element-220" />
            <p className="text-sm text-gray-400 mt-2" data-id="element-221">Ad Spend Analyzed</p>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-222">
            <AnimatedCounter value={340} suffix="+" data-id="element-223" />
            <p className="text-sm text-gray-400 mt-2" data-id="element-224">Agencies Onboarded</p>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-225">
            <AnimatedCounter value={12} suffix="M+" data-id="element-226" />
            <p className="text-sm text-gray-400 mt-2" data-id="element-227">Campaigns Tracked</p>
          </div>

          <div className="flex flex-col items-center justify-center" data-id="element-228">
            <AnimatedCounter value={99.7} suffix="%" data-id="element-229" />
            <p className="text-sm text-gray-400 mt-2" data-id="element-230">Uptime SLA</p>
          </div>
        </div>
      </div>
    </section>;
}